import { useState, useRef, useEffect, useContext, useCallback } from 'react';
import DotboldIcon from '../../../assets/img/dotsbold.svg';
import { useAoneStore } from '../../../store/AoneStore';
import { useConfigStore } from "../../../store/ConfigMgt/ConfigStore";
import { useCrmStore } from "../../../store/CrmMgt/CrmStore";
import { DateRangePicker } from 'rsuite';
import { PaginationMainTable } from '../../../components/Tables/PaginationMainTable';
import Dropdown from 'react-bootstrap/Dropdown';
import SearchInput from '../../../components/dropdown/AutoCompleteInput';
import AsyncSearchInput from '../../../components/dropdown/AutoCompleteAsync';
import { UserContext } from '../../../helper/ProtectedRoute';
import { roleHandler } from '../../../helper/roleHandler';
import TableComponent from '../Tables/CodArchive';
import CodDetailsTableComponent from '../Tables/CodPayableDetails';
import BulkEmailModal from './BulkEmailModal';
import { useCodAutomationStore } from '../../../store/CodAutomation/codAutomationStore';
import { Modal } from 'react-bootstrap';
import { showErrorToast } from '../../../components/Toast/Toaster';
import fileDownload from 'js-file-download';
import { Button } from '../../../components/UI/button';
import { Label } from '../../../components/UI/label';
import { RefreshCw, Search, Mail, ChevronLeft, ChevronRight } from 'lucide-react';
import dayjs from 'dayjs';
import '../../../styles/tailwind.css';
import '../../../styles/tailwind-shadcn-fixes.css';
import { useAbortableLoad } from '../../../components/UI/loading';

const CodArchive = ({ tab, setTab }) => {
    const [selectedOptionCustomer, setSelectedOptionCustomer] = useState(null);
    const [customer, setCustomer] = useState(null);
    const [destinationCountry, setDestinationCountry] = useState(null);
    const [selectedOptionCountry, setSelectedOptionCountry] = useState(null);
    const [dateRange, setDateRange] = useState([]);
    const [dateRangefil, setDateRangefil] = useState({});
    const [codPayables, setCodPayables] = useState([]);
    const [newPage, setNewPage] = useState(0);
    const [size, setSize] = useState(20);
    const [totalCount, setTotalCount] = useState(0);
    const [checkedCol, setCheckedCol] = useState([]);
    const [loadingMore, setLoadingMore] = useState(false);
    const [sortField, setSortField] = useState('-updatedAt');
    const [selectedRows, setSelectedRows] = useState([]);
    const [cusPage, setCusPage] = useState(-1);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [openViewModal, setOpenViewModal] = useState(false);
    const [codPayableDetails, setCodPayableDetails] = useState(null);
    // List request: skeleton, Cancel and latest-wins ordering. The service
    // takes no AbortSignal, so Cancel drops the response.
    const listLoad = useAbortableLoad();
    const isLoadingPage = listLoad.loading;
    const [openBulkEmailModal, setOpenBulkEmailModal] = useState(false);
    const [modalPage, setModalPage] = useState(0);
    const [modalSize, setModalSize] = useState(20);
    const [modalHasNext, setModalHasNext] = useState(false);
    const [isModalLoading, setIsModalLoading] = useState(false);
    const [modalSummaryItem, setModalSummaryItem] = useState(null);
    const modalViewItemRef = useRef(null);

    const isReactselectRegion = useAoneStore((state) => state?.isReactselectRegion);
    const isReactdesBulk = useAoneStore((state) => state?.isReactdesBulk);
    const setReactSelectregion = useAoneStore((state) => state?.setReactSelectregion);
    const setReactDesBulk = useAoneStore((state) => state?.setReactDesBulk);
    const setisReactRatestate = useAoneStore((state) => state?.setisReactRatestate);

    const countriesData = useConfigStore((state) => state?.countriesData);
    const filterCustomer = useCrmStore((state) => state?.filterCustomer);
    const filterCountries = useConfigStore((state) => state?.filterCountries);
    const storedCountryCodes = JSON.parse(sessionStorage.getItem('countryCodes'));
    const matchedCountries = countriesData?.data?.data?.content?.filter(
        (country) => storedCountryCodes?.includes(country.isoCode3)
    );
    const getCodArchiveSummary = useCodAutomationStore((state) => state?.getCodArchiveSummary);
    const getCodPayableDetails = useCodAutomationStore((state) => state?.getCodPayableDetails);
    const exportCodArchiveSummary = useCodAutomationStore((state) => state?.exportCodArchiveSummary);
    const sendCodBulkEmail = useCodAutomationStore((state) => state?.sendCodBulkEmail);
    const uploadBankReceipt = useCodAutomationStore((state) => state?.uploadBankReceipt);

    const [state] = useContext(UserContext);
    const [role, setRole] = useState(sessionStorage.getItem('user_access_role'));
    useEffect(() => {
        setRole(state.roles);
    }, [state.roles]);

    const canReconcile =
        roleHandler(role, 'AONE_FINANCE_COD_SEND_EMAIL.write') ||
        roleHandler(role, 'AONE_FINANCE_COD.admin');

    const ref = useRef();
    const dropdownRef = useRef(null);

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsDropdownOpen(false);
            setisReactRatestate(false);
        }
    };
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => { document.removeEventListener('mousedown', handleClickOutside); };
    }, []);

    const loadMoreOptions = useCallback(
        async (search) => {
            if (!loadingMore) {
                setLoadingMore(true);
                let nextPage = search ? 0 : cusPage + 1;
                if (nextPage === -1) nextPage = 0;
                setCusPage(nextPage);
                let endpoint = `?page=${nextPage}&size=20`;
                if (search) endpoint += `&customerAccount=${search}`;
                const response = await filterCustomer(endpoint);
                const options = response.data.data.content || [];
                setLoadingMore(false);
                return {
                    options: options.map((option) => ({
                        label: `${option.accountNumber} - ${option.name}`,
                        value: option.accountNumber,
                    })),
                    hasMore: options.length > 0,
                };
            }
            return { options: [], hasMore: false };
        },
        [loadingMore, cusPage]
    );

    useEffect(() => {
        let paramslink = `?page=${0}&size=${300}`;
        if (countriesData?.data?.data?.content?.length < 1 || countriesData?.length < 1) {
            filterCountries(paramslink);
        }
    }, []);

    const shouldLoadMore = (scrollHeight, clientHeight, scrollTop) => {
        const bottomBorder = (scrollHeight - clientHeight) / 2;
        return !loadingMore && bottomBorder < scrollTop;
    };

    const handleMenuOpenregion = () => setReactSelectregion(true);
    const handleMenuCloseregion = () => setReactSelectregion(false);
    const handleMenuOpenDesBulk = () => setReactDesBulk(true);
    const handleMenuCloseDesBulk = () => setReactDesBulk(false);

    const handlePaste = async (event) => {
        const pastedText = event.clipboardData.getData('text').trim();
        if (!pastedText) return;
        const accounts = pastedText.split(/[\s,]+/).filter((acc) => acc.length > 0);
        if (accounts.length === 0) return;
        const response = await filterCustomer(`?page=0&size=${accounts.length}&customerAccount=${accounts.join(',')}`);
        const options = response.data.data.content || [];
        if (options.length > 0) {
            const matchedOptions = options.map((option) => ({
                label: `${option.accountNumber} - ${option.name}`,
                value: option.accountNumber,
            }));
            setSelectedOptionCustomer((prev) => {
                if (Array.isArray(prev)) {
                    const newValues = matchedOptions.filter((opt) => !prev.some((p) => p.value === opt.value));
                    return [...prev, ...newValues];
                }
                return matchedOptions;
            });
            setCustomer((prev) => {
                const existing = prev ? prev.split(',') : [];
                const newVals = matchedOptions.map((opt) => opt.value);
                return [...new Set([...existing, ...newVals])].join(',');
            });
        }
    };

    const handleDateRangeChange = (value) => {
        if (value !== null) {
            setDateRange(value);
            const startDate = new Date(value[0]);
            startDate.setHours(0, 0, 0, 0);
            const endDate = new Date(value[1]);
            endDate.setHours(23, 59, 59, 999);
            const formatDate = (date) => date.getTime();
            setDateRangefil({ start: formatDate(startDate), end: formatDate(endDate) });
        } else {
            setDateRange([]);
            setDateRangefil([]);
        }
    };

    const getInitialData = useCallback(async () => {
        const requestBody = {
            page: 0,
            size: 20,
            customerAccounts: undefined,
            destinationCountry: destinationCountry || undefined,
            fromDate: 0,
            toDate: 0,
        };
        const data = await listLoad.track(() => getCodArchiveSummary(requestBody));
        setTotalCount(data?.data?.data?.totalElements);
        setCodPayables(data?.data?.data?.content);
    }, []);

    useEffect(() => {
        getInitialData();
    }, [getInitialData]);

    const getData = useCallback(async () => {
        try {
            const requestBody = {
                page: newPage,
                size,
                customerAccounts: customer ? customer.split(',').map((c) => c.trim()) : undefined,
                destinationCountry: destinationCountry || undefined,
                from: dateRangefil.start || undefined,
                to: dateRangefil.end || undefined,
            };
            const data = await listLoad.track(() => getCodArchiveSummary(requestBody));
            setTotalCount(data?.data?.data?.totalElements);
            setCodPayables(data?.data?.data?.content);
        } finally {
        }
    }, [getCodArchiveSummary, newPage, size, customer, destinationCountry, dateRangefil]);

    const handleApplyFilters = () => getData();

    useEffect(() => {
        if (codPayables?.length) {
            getData();
        }
    }, [newPage, size, sortField]);

    const handleRefresh = async () => getData();

    const handleCodArchiveSummaryExport = async () => {
        const requestBody = {
            customerAccounts: customer ? customer.split(',').map((c) => c.trim()) : undefined,
            destinationCountry: destinationCountry || undefined,
            from: dateRangefil.start || undefined,
            to: dateRangefil.end || undefined,
        };
        try {
            const response = await exportCodArchiveSummary(requestBody);
            if (response?.data) {
                fileDownload(response?.data, 'Cod-Summary.csv');
            } else {
                showErrorToast(response?.data?.error);
            }
        } catch (error) {
            showErrorToast(error?.msg || 'ERROR');
        }
    };

    const selectedRowData = codPayables?.filter((row) => selectedRows.includes(row?.summaryId)) ?? [];

    const handleBulkEmailModalClose = () => {
        setOpenBulkEmailModal(false);
        getData();
        setSelectedRows([]);
    };

    const fetchModalData = useCallback(async (page, size, item) => {
        const target = item || modalViewItemRef.current;
        if (!target) return;
        setIsModalLoading(true);
        try {
            const response = await getCodPayableDetails(target.customer, target.from, target.to, target.destinationCountry, page, size);
            if (response?.data?.status === 'SUCCESS') {
                setCodPayableDetails(response?.data?.data);
                setModalHasNext(response?.data?.data?.hasNext ?? false);
            } else {
                showErrorToast(response?.response?.data?.msg || 'ERROR');
            }
        } catch (error) {
            showErrorToast(error?.msg || 'ERROR');
        } finally {
            setIsModalLoading(false);
        }
    }, [getCodPayableDetails]);

    const handleViewClick = useCallback((item) => {
        const { summaryItem, ...viewParams } = item;
        modalViewItemRef.current = viewParams;
        setModalSummaryItem(summaryItem || null);
        setModalPage(0);
        setOpenViewModal(true);
        fetchModalData(0, modalSize, viewParams);
    }, [fetchModalData, modalSize]);

    const handleModalNextPage = () => {
        const next = modalPage + 1;
        setModalPage(next);
        fetchModalData(next, modalSize);
    };

    const handleModalPrevPage = () => {
        const prev = Math.max(0, modalPage - 1);
        setModalPage(prev);
        fetchModalData(prev, modalSize);
    };

    const handleModalSizeChange = (newSize) => {
        setModalSize(newSize);
        setModalPage(0);
        fetchModalData(0, newSize);
    };

    const handleNextPage = () => setNewPage((prev) => prev + 1);
    const handlePreviousPage = () => setNewPage((prev) => Math.max(0, prev - 1));
    const handlePageSizeChange = (newSize) => { setSize(newSize); setNewPage(0); };

    const gridId = 'finance.codArchive';
    const [column, setColumn] = useState([
        'Customer Account',
        'Customer Name',
        'Bank Charges',
        'Payable Amount',
        'Email Sent',
        'From Date',
        'To Date',
        'Generated On',
        'Generated',
        'Generated By',
        'Email Sent By',
        'Destination Country',
        'Status',
        'Reconciled At',
        'Reconciled By',
        'Action',
    ]);

    const handleSelect = (d) => {
        let val = checkedCol.includes(d);
        if (val) {
            setCheckedCol(checkedCol.filter((dat) => dat !== d));
        } else {
            setCheckedCol([...checkedCol, d]);
        }
    };

    useEffect(() => {
        const savedGrid = sessionStorage.getItem(gridId);
        if (savedGrid) {
            const parsedData = JSON.parse(savedGrid);
            if (parsedData.columns) setCheckedCol(parsedData.columns.split(','));
        }
    }, [gridId]);

    useEffect(() => {
        sessionStorage.setItem(gridId, JSON.stringify({ grid_id: gridId, columns: checkedCol.join(',') }));
    }, [checkedCol, gridId]);

    const sorting = (name) => {
        const value = sortField?.startsWith('-') ? '' : '-';
        setSortField(value + name);
    };

    return (
        <>
            <div className="px-3 py-2">
                {/* Filters */}
                <div className="mb-2">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
                        <div>
                            <Label className="text-xs text-gray-600 mb-1 block">Customer</Label>
                            <AsyncSearchInput
                                id="customer"
                                label="customer"
                                name="customer"
                                applySelectedStyles={true}
                                value={selectedOptionCustomer}
                                loadMoreOptions={loadMoreOptions}
                                shouldLoadMore={shouldLoadMore}
                                isMulti={true}
                                getOptionLabel={(zone) => zone.label}
                                getOptionValue={(zone) => zone.value}
                                onMenuOpen={handleMenuOpenregion}
                                onMenuClose={handleMenuCloseregion}
                                menuIsOpen={isReactselectRegion}
                                onChange={(selectedOptions) => {
                                    setSelectedOptionCustomer(selectedOptions);
                                    const selectedValues = Array.isArray(selectedOptions)
                                        ? selectedOptions.map((opt) => opt.value).join(', ')
                                        : '';
                                    setCustomer(selectedValues);
                                }}
                                placeholder="Customer"
                                onPaste={handlePaste}
                                menuPlacement="auto"
                                menuPosition="fixed"
                                menuStyle={{ zIndex: 9999 }}
                                customStyles={{ control: { width: '100%', backgroundColor: '#f3f4f6' } }}
                            />
                        </div>
                        <div>
                            <Label className="text-xs text-gray-600 mb-1 block">Destination Country</Label>
                            <SearchInput
                                id="countryCode"
                                label="countryCode"
                                name="countryName"
                                applySelectedStyles={true}
                                value={selectedOptionCountry}
                                options={matchedCountries || []}
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.isoCode3}
                                handleChange={(selectedOption) => {
                                    setSelectedOptionCountry(selectedOption);
                                    setDestinationCountry(selectedOption ? selectedOption.isoCode3 : '');
                                }}
                                onMenuOpen={handleMenuOpenDesBulk}
                                onMenuClose={handleMenuCloseDesBulk}
                                menuIsOpen={isReactdesBulk}
                                isClearable={true}
                                isSearchable={true}
                                placeholder="Destination Country"
                                customStyles={{ control: { width: '100%', backgroundColor: '#f3f4f6' } }}
                            />
                        </div>
                        <div>
                            <Label className="text-xs text-gray-600 mb-1 block">Date</Label>
                            <DateRangePicker
                                format="yyyy-MM-dd"
                                placeholder="Select Date"
                                value={dateRange}
                                onChange={handleDateRangeChange}
                                placement="auto"
                                cleanable={false}
                                style={{ width: '100%' }}
                            />
                        </div>
                    </div>
                </div>

                {/* Action Bar */}
                <div className="!mb-4">
                    <div className="flex justify-end items-center gap-2">
                        <Button
                            variant="outline"
                            onClick={() => {
                                setSelectedOptionCustomer(null);
                                setCustomer(null);
                                setSelectedOptionCountry(null);
                                setDestinationCountry(null);
                                setNewPage(0);
                            }}
                            className="!text-sm px-4 bg-white hover:!bg-gray-200"
                        >
                            Clear Filters
                        </Button>
                        <Button
                            onClick={handleApplyFilters}
                            className="bg-red-600 hover:bg-red-700 text-white !text-sm px-6"
                        >
                            <Search className="size-4 mr-2" />
                            Search
                        </Button>
                        {canReconcile && selectedRows?.length >= 1 && (
                            <Button
                                onClick={() => setOpenBulkEmailModal(true)}
                                className="bg-red-600 hover:bg-red-700 text-white !text-sm px-4"
                            >
                                <Mail className="size-4 mr-1" />
                                Reconcile
                            </Button>
                        )}
                        <Button
                            variant="outline"
                            onClick={handleCodArchiveSummaryExport}
                            className="!text-sm px-4 bg-white hover:!bg-gray-200"
                        >
                            Export
                        </Button>
                        <Button
                            variant="outline"
                            size="icon"
                            title="Sync"
                            onClick={handleRefresh}
                            className="bg-white hover:!bg-gray-200 p-0"
                        >
                            <RefreshCw className="size-4" />
                        </Button>
                        <div ref={ref} className="customFilter">
                            <Dropdown autoClose="outside">
                                <Dropdown.Toggle id="dropdown-basic" className="!border !border-gray-200 !bg-white hover:!bg-gray-200 !rounded-md !p-2 !shadow-none !text-gray-700">
                                    <img alt="More actions" src={DotboldIcon} />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item>
                                        <ul className="listColumn cursorPointer">
                                            {column?.map((d, i) => (
                                                <li key={d}>
                                                    <div className="smallCheckbox mb_4">
                                                        <input id={`product${i}`} type="checkbox" checked={!checkedCol.includes(d)} />
                                                        <label htmlFor={`product${i}`} onClick={() => handleSelect(d)}>{d}</label>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </div>

                <PaginationMainTable
                    pageSize={size}
                    setPageSize={handlePageSizeChange}
                    pageSizeOptions={[20, 50, 100]}
                    hasNext={(newPage + 1) * size < totalCount}
                    hasPrev={newPage > 0}
                    onNextPage={handleNextPage}
                    onPreviousPage={handlePreviousPage}
                    isLoadingPage={isLoadingPage}
                    loadingLabel="Loading COD archive"
                    onCancelLoading={listLoad.cancel}
                    cancelled={listLoad.cancelled}
                    pageNo={newPage}
                    wrapperClassName="rounded-lg border border-gray-200 overflow-hidden"
                >
                    <TableComponent
                        tableData={codPayables}
                        restrict={checkedCol}
                        newPage={newPage}
                        size={size}
                        sortField={sortField}
                        sorting={sorting}
                        selectedRows={selectedRows}
                        setSelectedRows={setSelectedRows}
                        onViewClick={handleViewClick}
                        fetchPageData={getData}
                        isLoadingPage={isLoadingPage}
                    />
                </PaginationMainTable>
            </div>

            {openViewModal && (
                <Modal
                    className="addnewPerformanceModal"
                    show={openViewModal}
                    onHide={() => { setOpenViewModal(false); setCodPayableDetails(null); setModalSummaryItem(null); modalViewItemRef.current = null; }}
                >
                    <Modal.Header closeButton>
                        <h4 className="fontSize16 blackText fontWeight500">
                            {codPayableDetails?.customerAccount} - {codPayableDetails?.customerName}
                        </h4>
                    </Modal.Header>
                    {modalSummaryItem && (
                        <div className="px-3 pt-2 pb-2 border-b border-gray-200 bg-gray-50">
                            <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider mb-1.5">Summary</p>
                            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-1.5">
                                <div className="bg-white rounded border border-gray-200 px-2.5 py-1.5">
                                    <p className="text-[10px] text-gray-400">Customer Account</p>
                                    <p className="text-xs font-semibold text-gray-800 mt-0.5 truncate">{modalSummaryItem?.customerAccount ?? '-'}</p>
                                </div>
                                <div className="bg-white rounded border border-gray-200 px-2.5 py-1.5">
                                    <p className="text-[10px] text-gray-400">Customer Name</p>
                                    <p className="text-xs font-semibold text-gray-800 mt-0.5 truncate">{modalSummaryItem?.customerName ?? '-'}</p>
                                </div>
                                <div className="bg-white rounded border border-gray-200 px-2.5 py-1.5">
                                    <p className="text-[10px] text-gray-400">Payable Amount</p>
                                    <p className="text-xs font-semibold text-gray-800 mt-0.5">{modalSummaryItem?.payable ?? '-'}</p>
                                </div>
                                 <div className="bg-white rounded border border-gray-200 px-2.5 py-1.5">
                                    <p className="text-[10px] text-gray-400">Bank Charges</p>
                                    <p className="text-xs font-semibold text-gray-800 mt-0.5">{modalSummaryItem?.bankCharges ?? '-'}</p>
                                </div>
                                <div className="bg-white rounded border border-gray-200 px-2.5 py-1.5">
                                    <p className="text-[10px] text-gray-400">Status</p>
                                    <span className={`inline-flex items-center mt-0.5 px-1.5 py-0.5 rounded-full text-[10px] font-semibold ${
                                        modalSummaryItem?.status === 'RECONCILED' ? 'bg-green-100 text-green-800' :
                                        modalSummaryItem?.status === 'PENDING' ? 'bg-yellow-100 text-yellow-800' :
                                        'bg-gray-100 text-gray-700'
                                    }`}>{modalSummaryItem?.status ?? '-'}</span>
                                </div>
                                <div className="bg-white rounded border border-gray-200 px-2.5 py-1.5">
                                    <p className="text-[10px] text-gray-400">From Date</p>
                                    <p className="text-xs font-semibold text-gray-800 mt-0.5">{modalSummaryItem?.from ? dayjs(modalSummaryItem.from).format('DD MMM YYYY') : '-'}</p>
                                </div>
                                <div className="bg-white rounded border border-gray-200 px-2.5 py-1.5">
                                    <p className="text-[10px] text-gray-400">To Date</p>
                                    <p className="text-xs font-semibold text-gray-800 mt-0.5">{modalSummaryItem?.to ? dayjs(modalSummaryItem.to).format('DD MMM YYYY') : '-'}</p>
                                </div>
                                <div className="bg-white rounded border border-gray-200 px-2.5 py-1.5">
                                    <p className="text-[10px] text-gray-400">Generated On</p>
                                    <p className="text-xs font-semibold text-gray-800 mt-0.5">{modalSummaryItem?.generatedOn ? dayjs(modalSummaryItem.generatedOn).format('DD MMM YYYY, hh:mm A') : '-'}</p>
                                </div>
                                <div className="bg-white rounded border border-gray-200 px-2.5 py-1.5">
                                    <p className="text-[10px] text-gray-400">Destination Country</p>
                                    <p className="text-xs font-semibold text-gray-800 mt-0.5">{modalSummaryItem?.destinationCountryCode ?? '-'}</p>
                                </div>
                                <div className="bg-white rounded border border-gray-200 px-2.5 py-1.5">
                                    <p className="text-[10px] text-gray-400">Email Sent</p>
                                    <span className={`inline-flex items-center mt-0.5 px-1.5 py-0.5 rounded-full text-[10px] font-semibold ${modalSummaryItem?.emailSent ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-700'}`}>
                                        {modalSummaryItem?.emailSent ? 'Yes' : 'No'}
                                    </span>
                                </div>
                                <div className="bg-white rounded border border-gray-200 px-2.5 py-1.5">
                                    <p className="text-[10px] text-gray-400">Generated By</p>
                                    <p className="text-xs font-semibold text-gray-800 mt-0.5">{modalSummaryItem?.generatedBy ?? '-'}</p>
                                </div>
                                <div className="bg-white rounded border border-gray-200 px-2.5 py-1.5">
                                    <p className="text-[10px] text-gray-400">Email Sent By</p>
                                    <p className="text-xs font-semibold text-gray-800 mt-0.5">{modalSummaryItem?.emailSentBy ?? '-'}</p>
                                </div>
                                <div className="bg-white rounded border border-gray-200 px-2.5 py-1.5">
                                    <p className="text-[10px] text-gray-400">Reconciled At</p>
                                    <p className="text-xs font-semibold text-gray-800 mt-0.5">{modalSummaryItem?.reconciledAt ? dayjs(Number(modalSummaryItem.reconciledAt)).format('DD MMM YYYY, hh:mm A') : '-'}</p>
                                </div>
                                <div className="bg-white rounded border border-gray-200 px-2.5 py-1.5">
                                    <p className="text-[10px] text-gray-400">Reconciled By</p>
                                    <p className="text-xs font-semibold text-gray-800 mt-0.5">{modalSummaryItem?.reconciledBy ?? '-'}</p>
                                </div>
                            </div>
                        </div>
                    )}
                    <div style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                        <Modal.Body>
                            <div className="table_wrapper">
                                <table>
                                    <CodDetailsTableComponent tableData={codPayableDetails?.consignments || []} isLoading={isModalLoading} />
                                </table>
                            </div>
                        </Modal.Body>
                    </div>
                    <Modal.Footer className="border-t border-gray-200 bg-gray-50 px-4 py-2">
                        <div className="flex items-center justify-end gap-4 w-full">
                            <div className="flex items-center gap-2">
                                <span className="text-xs text-gray-600">Rows per page:</span>
                                <select
                                    value={modalSize}
                                    onChange={(e) => handleModalSizeChange(Number(e.target.value))}
                                    className="text-xs border border-gray-300 rounded-md px-2 py-1 bg-white hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#EC171C] focus-visible:ring-offset-1"
                                    disabled={isModalLoading}
                                >
                                    {[20, 50, 100].map((opt) => (
                                        <option key={opt} value={opt}>{opt}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="flex items-center gap-2">
                                <button
                                    onClick={handleModalPrevPage}
                                    disabled={modalPage === 0 || isModalLoading}
                                    className="!p-1.5 rounded-md !border border-gray-300 border-solid bg-white hover:!bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                                    title="Previous page"
                                >
                                    <ChevronLeft className="size-4 text-gray-600" />
                                </button>
                                <button
                                    onClick={handleModalNextPage}
                                    disabled={!modalHasNext || isModalLoading}
                                    className="!p-1.5 rounded-md !border border-gray-300 border-solid bg-white hover:!bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                                    title="Next page"
                                >
                                    <ChevronRight className="size-4 text-gray-600" />
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            )}

            {openBulkEmailModal && selectedRowData.length > 0 && (
                <BulkEmailModal
                    rows={selectedRowData}
                    onClose={handleBulkEmailModalClose}
                    uploadAttachment={uploadBankReceipt}
                />
            )}
        </>
    );
};

export default CodArchive;
